import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PlanForm from '../components/PlanForm';
import { useDispatch, useSelector } from 'react-redux';
import { cancelPlanCreate, createPlanRequest } from '../../api/plans/planSlice';
import { regionFeatures } from '../../utils/features';

const PlanCreatePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isPlanCreated } = useSelector((state) => state.plans);

  useEffect(() => {
    if (isPlanCreated) {
      navigate('/plans');
    }
  }, [isPlanCreated, navigate]);

  const handleCreate = async (data) => {
    dispatch(createPlanRequest(data));
  };

  function handleCancel() {
    dispatch(cancelPlanCreate());
    return navigate('/plans');
  }

  return (
    <Box elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 6 }}>
        Create Plan
      </Typography>
      <PlanForm
        onSubmit={handleCreate}
        onCancel={handleCancel}
        buttonText="Save"
        initialData={{
          name: '',
          description: '',
          self_serve: false,
          position: 1,
          billing_interval: { value: 1, unit: 'month' },
          type: 'prepaid',
          price: 0,
          due_after: 0,
          documents_limit: 1,
          recurrence_limit: 0,
          pricing_model: 'licensed',
          billing_schema: null,
        }}
      />
    </Box>
  );
};

export default PlanCreatePage;
